<form [formGroup]="inputForm" class="top-search">
  <mat-form-field appearance="outline" class="w-p-100 no-mat-label flex flex-col" style="postion: relative">
    <input formControlName="searchQuery" matInput placeholder="Start typing here..."
           rows="1" type="text" [matAutocomplete]="suggestionPanel"/>

    <mat-autocomplete #suggestionPanel="matAutocomplete">
      <mat-option *ngFor="let suggestion of suggestions; let i = index"
                  (onSelectionChange)="onClickedSuggestion(suggestion)">
        <span title="{{suggestion.group}}">{{suggestion.group}}</span>
        <span title="{{suggestion.displayQuery}}">{{suggestion.displayQuery}}</span>
      </mat-option>
    </mat-autocomplete>
    <button mat-button (click)="onClickedPowerSearch($event)" class="power-search-btn">Power Search</button>
  </mat-form-field>

</form>


<div class="grid-toolbar-buttons-group-without-label flex flex-row flex-wrap justify-start items-center">
  <button *ngFor="let flatQuery of flatQueries.reports; let i = index" (click)="onFlatQueryClicked(i)"
          class="flat-query-button" mat-button>
    {{flatQuery.displayQuery}}
  </button>
</div>
